import { isDevelopmentEnvironment } from "@/lib/env";
import { isCustomerGroupAddressEnabled } from "./customerGroupAddressFeature";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const PHYSICAL_CLIENT_DEV_ONLY = true;

export let isPhysicalClientEnabled = false;

// Cadastro de cliente pessoa física (CPF): Backoffice > Clientes > Pessoa física (lista, cadastro e detalhe com
// endereços, histórico e registro de acesso ao CPF). Depende do cadastro de grupos e endereços
// (customerGroupAddressFeature) e só liga junto com ele. Desligada, menu e rotas ficam como antes.
// Comente a linha abaixo para desativar a funcionalidade no frontend.
// Mantenha em sincronia com Features/PhysicalClientFeature.cs do backend.
isPhysicalClientEnabled = isCustomerGroupAddressEnabled && (!PHYSICAL_CLIENT_DEV_ONLY || isDevelopmentEnvironment);
